import type { SessionLog } from "./game/log";

// Скрытая панель фасилитатора (GDD 6.4 / бриф п.28). Не видна ребёнку:
// открывается тройным касанием правого верхнего угла или ?dev=1.
// Позволяет: вкл/выкл STT, ручной выбор числа, переход к моменту, сброс мира,
// смотреть raw transcript / extracted number / confidence / latency, экспорт лога.

export interface DevHooks {
  toggleStt(on: boolean): void;
  switchRecognizer(name: "elevenlabs" | "webspeech"): void;
  jumpToMoment(n: number): void;
  resetWorld(): void;
  forceCuckoo(): void;
  exportLog(): void;
  postLog(): void;
}

export class DevPanel {
  private el: HTMLDivElement;
  private open = false;
  private sttOn = true;
  private kv: Record<string, HTMLElement> = {};
  private logEl: HTMLDivElement;

  constructor(private hooks: DevHooks, log: SessionLog) {
    const hotspot = document.createElement("div");
    hotspot.id = "dev-hotspot";
    document.body.appendChild(hotspot);

    let taps = 0;
    let last = 0;
    const tap = () => {
      const now = Date.now();
      taps = now - last < 1200 ? taps + 1 : 1;
      last = now;
      if (taps >= 3) {
        taps = 0;
        this.toggle();
      }
    };
    hotspot.addEventListener("pointerup", tap);

    this.el = document.createElement("div");
    this.el.id = "dev-panel";
    this.el.innerHTML = `
      <h3>Распознавание</h3>
      <div class="row">
        <button data-a="stt">STT: вкл</button>
        <button data-a="rec-el">ElevenLabs</button>
        <button data-a="rec-ws">WebSpeech</button>
      </div>
      <div class="row kv">raw: <b id="k-raw">—</b></div>
      <div class="row kv">число: <b id="k-num">—</b></div>
      <div class="row kv">confidence: <b id="k-conf">—</b></div>
      <div class="row kv">STT ms: <b id="k-stt">—</b> · total: <b id="k-total">—</b></div>
      <div class="row kv">median: <b id="k-med">—</b> · p95: <b id="k-p95">—</b></div>
      <div class="row kv">фраза/число/промах: <b id="k-cnt">0/0/0</b></div>
      <div class="row kv">phase: <b id="k-phase">—</b> · t: <b id="k-t">0</b></div>

      <h3>Мир</h3>
      <div class="row" id="jump-row"></div>
      <div class="row">
        <button data-a="reset">Сброс мира</button>
        <button data-a="cuckoo">Реплика Кукушки</button>
      </div>

      <h3>Лог</h3>
      <div class="row">
        <button data-a="export">Скачать JSON</button>
        <button data-a="post">Отправить на сервер</button>
      </div>
      <div id="dev-log"></div>
    `;
    document.body.appendChild(this.el);

    for (let i = 0; i <= 10; i++) {
      const b = document.createElement("button");
      b.textContent = String(i);
      b.addEventListener("click", () => this.hooks.jumpToMoment(i));
      this.el.querySelector("#jump-row")!.appendChild(b);
    }

    this.logEl = this.el.querySelector("#dev-log") as HTMLDivElement;
    for (const id of ["raw", "num", "conf", "stt", "total", "med", "p95", "cnt", "phase", "t"]) {
      this.kv[id] = this.el.querySelector(`#k-${id}`) as HTMLElement;
    }

    this.el.addEventListener("click", (e) => {
      const a = (e.target as HTMLElement).dataset.a;
      if (!a) return;
      if (a === "stt") {
        this.sttOn = !this.sttOn;
        (e.target as HTMLElement).textContent = `STT: ${this.sttOn ? "вкл" : "выкл"}`;
        this.hooks.toggleStt(this.sttOn);
      } else if (a === "rec-el") this.hooks.switchRecognizer("elevenlabs");
      else if (a === "rec-ws") this.hooks.switchRecognizer("webspeech");
      else if (a === "reset") this.hooks.resetWorld();
      else if (a === "cuckoo") this.hooks.forceCuckoo();
      else if (a === "export") this.hooks.exportLog();
      else if (a === "post") this.hooks.postLog();
    });

    log.onEntry((entry) => {
      const line = `${(entry.t / 1000).toFixed(1)}s ${entry.kind}${entry.data ? " " + JSON.stringify(entry.data) : ""}`;
      this.logEl.textContent = (line + "\n" + this.logEl.textContent).slice(0, 6000);
    });

    if (new URLSearchParams(location.search).has("dev")) this.toggle();
    window.addEventListener("keydown", (e) => {
      if (e.key === "d" && (e.metaKey || e.ctrlKey)) this.toggle();
    });
  }

  private toggle() {
    this.open = !this.open;
    this.el.classList.toggle("open", this.open);
  }

  set(id: string, value: string) {
    if (this.kv[id]) this.kv[id].textContent = value;
  }
}
